(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  "use strict";
  var WA = "40747494949";

  function init(){
    var root = document.querySelector('.bf-lp');
    if (!root) return; /* no-op on every page that is not the BF landing page */

    document.body.classList.add('bf-lp-page');
    try { document.documentElement.style.scrollBehavior = 'smooth'; } catch(e){}

    /* --- Conversion tracking (guarded; no duplicate LP view) --- */
    function track(name, params){
      params = params || {};
      try { if (window.dataLayer) window.dataLayer.push(Object.assign({event: name}, params)); } catch(e){}
      try { if (typeof fbq === 'function') fbq('trackCustom', name, params); } catch(e){}
      try { if (typeof gtag === 'function') gtag('event', name, params); } catch(e){}
    }
    track('BF_LP_View', {page: 'black-friday-2026'});
    root.querySelectorAll('[data-track]').forEach(function(el){
      el.addEventListener('click', function(){
        var name = el.getAttribute('data-track');
        var card = el.closest('.bf-card');
        var label = (card && card.querySelector('.nm')) ? card.querySelector('.nm').textContent : (el.textContent||'').trim();
        track(name, {label: label});
      });
    });

    var sticky = root.querySelector('.sticky-wa');

    /* --- Keep the sticky CTA clear of Shopify's consent banner.
           Read-only: measures the banner, never touches consent logic or the
           banner itself. The banner stays on top and fully clickable. --- */
    function syncConsentOffset(){
      if (!sticky) return;
      var h = 0;
      try {
        var banner = document.getElementById('shopify-pc__banner');
        if (banner) {
          var cs = window.getComputedStyle(banner);
          var r = banner.getBoundingClientRect();
          var onScreen = cs.display !== 'none' && cs.visibility !== 'hidden' &&
                         parseFloat(cs.opacity || '1') > 0.01 &&
                         r.height > 0 && r.bottom > (window.innerHeight - 2);
          if (onScreen) h = Math.ceil(r.height);
        }
      } catch(e){ h = 0; }
      sticky.style.bottom = h ? h + 'px' : '';
      document.body.style.setProperty('--bf-consent-offset', h + 'px');
    }
    syncConsentOffset();
    var consentChecks = 0;
    var consentTimer = window.setInterval(function(){
      consentChecks += 1;
      syncConsentOffset();
      if (consentChecks >= 60) window.clearInterval(consentTimer);
    }, 500);
    window.addEventListener('resize', syncConsentOffset);
    window.addEventListener('orientationchange', syncConsentOffset);
    document.addEventListener('visitorConsentCollected', function(){
      syncConsentOffset();
      window.setTimeout(syncConsentOffset, 400);
    });

    /* --- Black Friday appointment capture.
           Every appointment CTA opens this form; WhatsApp is offered only after
           submission. Sends in parallel to the existing GHL external-tracking
           endpoint and the existing n8n webhook. No new credentials or fields. --- */
    (function initBlackFridayLeadForm(){
      var form = document.getElementById('bfLeadForm');
      if (!form) return;
      var error = document.getElementById('bfFormError');
      var success = document.getElementById('bfFormSuccess');
      var waLink = document.getElementById('bfContinueWhatsApp');
      var formSection = document.getElementById('bf-appointment');

      if (sticky && formSection) {
        var updateSticky = function(){
          var rect = formSection.getBoundingClientRect();
          var inFormView = rect.top < window.innerHeight * 0.92 && rect.bottom > window.innerHeight * 0.08;
          sticky.classList.toggle('is-hidden', inFormView || formSection.contains(document.activeElement));
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        formSection.addEventListener('focusin', function(){ sticky.classList.add('is-hidden'); });
        formSection.addEventListener('focusout', function(){ setTimeout(updateSticky, 200); });
        updateSticky();
      }

      var pendingContext = '';
      var locked = false;
      var TRACKING_ID = 'tk_350c640b9e4847e39aa9e0bddd4b1feb';
      var LOCATION_ID = 'X876lDBzHfz8dcDak9lk';
      var PROJECT_ID = '1786015012157364740';
      var CF = {
        tipSolicitare:'agEZ6INxNDO6ObK0BFv8', tipRochie:'8q92hRcDKVRBUqCmv4OB',
        urlSursa:'4xzAb3xBxCH965DE8xPU', utmSource:'E77BozLFCEz7PdOXFaTW',
        utmMedium:'Os7qOYHBed9KTrLbFelm', utmCampaign:'xqZWAp1p1WXWXd9VSohx',
        mesajLead:'72BKADYZSbb5bxmpXTYx', gclid:'Cc7FtiVQmm13ARObAve3',
        gbraid:'SAJPkTGUJm7rsajVNmug', wbraid:'pno6tTt9kWeqyJXUB7Bv',
        firstLandingUrl:'Dh5NTajxZzQumzB7iBy9', firstTouchTimestamp:'ycDn0fz0fPUqK4GqZenz'
      };
      function val(id){ var el = document.getElementById(id); return el ? (el.value||'').trim() : ''; }
      function attr(){
        try { if (window.AltesseAttribution && typeof window.AltesseAttribution.get === 'function') return window.AltesseAttribution.get() || {}; } catch(e){}
        return {};
      }
      function utms(a){
        var p = new URLSearchParams(window.location.search);
        return { s:a.utm_source||p.get('utm_source')||'', m:a.utm_medium||p.get('utm_medium')||'', c:a.utm_campaign||p.get('utm_campaign')||'' };
      }
      function showError(text){ if (error){ error.textContent = text; error.style.display = 'block'; } }
      function sendToGHL(o){
        try {
          var a = attr(), u = utms(a), parts = o.name.trim().split(/\s+/), data = {}, labels = {};
          if (parts[0]){ data.first_name = parts[0]; labels.first_name = 'Prenume'; }
          if (parts.length > 1){ data.last_name = parts.slice(1).join(' '); labels.last_name = 'Nume'; }
          data.phone = o.phone; labels.phone = 'Telefon';
          data.email = o.email; labels.email = 'Email';
          data.source = 'Programare în atelier'; labels.source = 'Sursă formular';
          data[CF.tipSolicitare] = 'Programare în atelier'; labels[CF.tipSolicitare] = 'Tip solicitare';
          data[CF.tipRochie] = o.dress; labels[CF.tipRochie] = 'Tip rochie';
          data[CF.mesajLead] = o.message; labels[CF.mesajLead] = 'Mesaj lead';
          data[CF.urlSursa] = window.location.href; labels[CF.urlSursa] = 'URL pagină sursă';
          if (u.s){ data[CF.utmSource] = u.s; labels[CF.utmSource] = 'UTM Source'; }
          if (u.m){ data[CF.utmMedium] = u.m; labels[CF.utmMedium] = 'UTM Medium'; }
          if (u.c){ data[CF.utmCampaign] = u.c; labels[CF.utmCampaign] = 'UTM Campaign'; }
          ['gclid','gbraid','wbraid','firstLandingUrl','firstTouchTimestamp'].forEach(function(k){
            if (a[k]){ data[CF[k]] = a[k]; labels[CF[k]] = k; }
          });
          var payload = {
            type:'external_form_submission', timestamp:Date.now(), formId:'programare-atelier',
            formData:data, formLabels:labels,
            url:window.location.href, title:document.title, path:window.location.pathname, userAgent:navigator.userAgent,
            trackingId:TRACKING_ID, locationId:LOCATION_ID, projectId:PROJECT_ID,
            sessionId:(window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now())),
            properties:{ deviceType:/Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop', source:'ai_studio', projectId:PROJECT_ID, formName:'Programare în atelier' }
          };
          var body = new FormData();
          body.append('event', JSON.stringify(payload));
          fetch('https://backend.leadconnectorhq.com/external-tracking/events', { method:'POST', headers:{ version:'2021-07-28' }, body:body, keepalive:true }).catch(function(){});
        } catch(e){}
      }
      function sendToN8N(o){
        try {
          fetch('https://n8n.dobrinsystems.com/webhook/altesse-lead', {
            method:'POST', keepalive:true,
            body: JSON.stringify({
              source:'programare-atelier', website:'altesse.ro',
              name:o.name, phone:o.phone, email:o.email,
              q1:o.dress, q2:'', q3:'', q4:'', q5:'Programare in atelier',
              message:o.message, gdprAt:o.stamp, marketingOk:o.marketingOk
            })
          }).catch(function(){});
        } catch(e){}
      }

      root.querySelectorAll('.wa-link').forEach(function(a){
        a.addEventListener('click', function(e){
          e.preventDefault();
          pendingContext = a.getAttribute('data-wa-msg') || '';
          var select = document.getElementById('bfDress');
          if (select){
            if (/mireasă/i.test(pendingContext)) select.value = 'Rochie de mireasă';
            else if (/ocazie/i.test(pendingContext)) select.value = 'Rochie de seară';
          }
          var hidden = document.getElementById('bfProductContext');
          if (hidden) hidden.value = pendingContext;
          if (sticky) sticky.classList.add('is-hidden');
          if (formSection) formSection.scrollIntoView({ behavior:'smooth', block:'center' });
          var nameInput = document.getElementById('bfName');
          if (nameInput) setTimeout(function(){ nameInput.focus({ preventScroll:true }); }, 350);
        });
      });

      form.addEventListener('submit', function(e){
        e.preventDefault();
        if (locked) return;
        if (error){ error.textContent = ''; error.style.display = 'none'; }
        var name = val('bfName'), email = val('bfEmail'), phone = val('bfPhone'), dress = val('bfDress');
        var gdpr = !!document.getElementById('bfGdpr').checked;
        var marketingOk = !!document.getElementById('bfMarketing').checked;
        if (name.length < 3 || name.split(/\s+/).length < 2){ showError('Te rugăm să completezi numele și prenumele.'); return; }
        if (!email || email.indexOf('@') < 1){ showError('Te rugăm să introduci o adresă de email validă.'); return; }
        if (phone.replace(/\D/g,'').length < 10){ showError('Te rugăm să introduci un număr de telefon valid (minim 10 cifre).'); return; }
        if (!dress){ showError('Selectează ce tip de rochie cauți.'); return; }
        if (!gdpr){ showError('Pentru a trimite cererea, acceptă prelucrarea datelor conform Politicii de confidențialitate.'); return; }

        locked = true;
        var button = form.querySelector('[type="submit"]');
        if (button){ button.disabled = true; button.textContent = 'Se trimite…'; }
        var stamp = new Date().toISOString();
        var message = 'Campanie: Black Friday Altesse (6–15 noiembrie 2026)\nTip rochie: ' + dress + '\n' +
          (pendingContext ? 'Interes specific: ' + pendingContext + '\n' : '') +
          'Pagina sursă: ' + window.location.href + '\n' +
          'Acord prelucrare date: Da (' + stamp + ')\nConsimțământ marketing: ' + (marketingOk ? 'Da (' + stamp + ')' : 'Nu');
        var lead = { name:name, email:email, phone:phone, dress:dress, message:message, stamp:stamp, marketingOk:marketingOk };
        sendToGHL(lead);
        sendToN8N(lead);

        var waMessage = 'Bună ziua! Am trimis o cerere de programare pentru Black Friday la Altesse.\n' +
          'Nume: ' + name + '\nTelefon: ' + phone + '\nEmail: ' + email + '\nTip rochie: ' + dress +
          (pendingContext ? '\nInteres: ' + pendingContext : '') + '\nPerioada campaniei: 6–15 noiembrie.';
        if (waLink) waLink.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(waMessage);
        form.style.display = 'none';
        if (success) success.style.display = 'block';
        if (sticky) sticky.classList.add('is-hidden');
        track('BF_Form_Submission_Attempt', { category: dress, source: 'black-friday-lp' });
      });
    })();

    /* --- Functional countdown (Europe/Bucharest, fixed targets, no reload reset) --- */
    var start = new Date('2026-11-06T00:00:00+02:00').getTime();
    var end   = new Date('2026-11-15T23:59:59+02:00').getTime();
    var urg = root.querySelector('#urg');
    var stateEl = root.querySelector('#cdState');
    var dEl = root.querySelector('#cdD'), hEl = root.querySelector('#cdH');
    var mEl = root.querySelector('#cdM'), sEl = root.querySelector('#cdS');
    if (!urg || !stateEl || !dEl || !hEl || !mEl || !sEl) return;

    var timer = null;
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){
      var now = Date.now(), target, label;
      if (now < start){ target = start; label = 'Campania începe în'; }
      else if (now <= end){ target = end; label = 'Se încheie în'; }
      else {
        stateEl.textContent = 'Campania s-a încheiat';
        urg.classList.add('ended');
        if (timer) clearInterval(timer);
        return;
      }
      stateEl.textContent = label;
      var diff = Math.max(0, target - now);
      dEl.textContent = pad(Math.floor(diff/86400000));
      hEl.textContent = pad(Math.floor(diff%86400000/3600000));
      mEl.textContent = pad(Math.floor(diff%3600000/60000));
      sEl.textContent = pad(Math.floor(diff%60000/1000));
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
